import React, { useState, useEffect } from 'react';
import { SAFARI_BROWSER, YANDEX_BROWSER } from '../constant';
import { useTranslation } from 'react-i18next';
import { ERROR_TYPE, loginManager } from './loginManager';
import PasswordMessage from './PasswordMessage';
import { Input } from '@chapche/ui';

const checkIsYandexOrSafariBrowser = () => {
    return window.navigator.userAgent.includes(YANDEX_BROWSER) || window.navigator.userAgent.includes(SAFARI_BROWSER);
};

const PasswordField = ({label, passwordType}) => {
    const { i18n } = useTranslation();
    const [error, setError] = useState({type: '', message: '', key: ''});
    const [passwordIsShown, setPasswordIsShown] = useState(false);
    const [password, setPassword] = useState('');

    const changeMessage = () => {
        setError(loginManager.getError());
    };

    const changePasswordField = (e) => {
        setPassword(e.target.value);
        loginManager.updatePasswordValue(passwordType, e.target.value);
    };

    const changePasswordVisibility = () => {
        setPasswordIsShown(!passwordIsShown);
    };
    
    useEffect(() => {
        loginManager.registerLoginUpdateObserver(changeMessage);
        changeMessage();
        return () => {
            loginManager.unRegisterLoginUpdateObserver(changeMessage);
        };
    }, []);

    return (
        <label className="block__text password__label" 
            autoComplete="off"
            key={label}
            name={label}>
            {label}
            {checkIsYandexOrSafariBrowser() ?
                <input type="password" autoComplete="off" style={{display: 'none'}} />
                :
                null}
            <Input
                fullWidth
                className="mt-0"
                type={!passwordIsShown && password ? "password" : "text"}
                value={password}
                onChange={changePasswordField}
                autoComplete="off"
                state={error.key.includes(passwordType) && error.type === ERROR_TYPE ? 'error' : 'default'}
            />
            {password ? 
                <span className="block__bullet password__text" onClick={changePasswordVisibility} >
                    {passwordIsShown ? i18n.t('public.app.page.login.hide') : i18n.t('public.app.page.login.show')}
                </span>
                :
                null}
            <PasswordMessage passwordType={passwordType} />
        </label>
    );
};

export default PasswordField;
